/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Elegant_Frail_Toucan_AdoreInputs */

const fr_elegant_frail_toucan_adore = /** @type {(inputs: Elegant_Frail_Toucan_AdoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement`)
};

/**

* @param {Elegant_Frail_Toucan_AdoreInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const elegant_frail_toucan_adore = /** @type {((inputs?: Elegant_Frail_Toucan_AdoreInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Elegant_Frail_Toucan_AdoreInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_elegant_frail_toucan_adore(inputs)
});